import { useNavigate } from 'react-router-dom';
import { BurgerMenu as BurgerMenuComponent } from '../../components/BurgerMenu';

export const BurgerMenu = () => {
    const navigate = useNavigate();

    return <BurgerMenuComponent onClick={() => navigate('/menu')} />;
};
